var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestLibraryIconPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30.892px",
    height: "20.376px",
    viewBox: "0 0 30.892 20.376",
    enableBackground: "new 0 0 30.892 20.376",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.781,8.813h-0.986c-0.001,0.924-0.747,1.67-1.673,1.673c-0.924-0.003-1.671-0.749-1.672-1.673 c0.001-0.924,0.748-1.67,1.672-1.672c0.926,0.002,1.672,0.748,1.673,1.672H27.781h0.985c0-2.014-1.631-3.644-3.645-3.644 c-2.013,0-3.645,1.63-3.645,3.644c0,2.013,1.632,3.644,3.645,3.645c2.014-0.001,3.645-1.632,3.645-3.645H27.781z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.539,5.08h-0.985c-0.002,1.717-1.393,3.105-3.108,3.109c-1.716-0.004-3.106-1.393-3.109-3.109 c0.003-1.716,1.392-3.104,3.109-3.107c1.716,0.003,3.106,1.393,3.108,3.107H19.539h0.987C20.524,2.274,18.249,0.001,15.445,0 c-2.807,0.001-5.079,2.274-5.081,5.08c0,2.807,2.274,5.08,5.081,5.081c2.804-0.001,5.079-2.274,5.081-5.081H19.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3.108,8.813H2.123c0,2.013,1.63,3.644,3.644,3.645c2.013-0.001,3.645-1.631,3.646-3.645 C9.411,6.799,7.779,5.17,5.767,5.17c-2.014,0-3.644,1.631-3.644,3.644H3.108h0.986c0.002-0.925,0.748-1.67,1.672-1.672 C6.69,7.144,7.438,7.891,7.44,8.813c-0.002,0.923-0.75,1.67-1.674,1.673c-0.924-0.003-1.67-0.749-1.672-1.673H3.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.892,19.39v-1.441c-0.002-2.359-1.911-4.271-4.271-4.272h-1.055c-0.544,0-0.986,0.442-0.986,0.986 s0.442,0.985,0.986,0.985h1.055c1.269,0.003,2.297,1.031,2.3,2.301v1.441c0,0.544,0.441,0.986,0.985,0.986 C30.45,20.376,30.892,19.934,30.892,19.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.972,19.39v-1.441c0.003-1.27,1.031-2.298,2.301-2.301h1.053c0.544,0,0.986-0.441,0.986-0.985 s-0.442-0.986-0.986-0.986H4.272C1.911,13.677,0.001,15.589,0,17.948v1.441c0,0.544,0.442,0.986,0.985,0.986 C1.53,20.376,1.972,19.934,1.972,19.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.45,19.39v-2.105c-0.002-3.085-2.501-5.586-5.588-5.587h-4.836c-3.087,0.001-5.586,2.502-5.586,5.587 v2.105c0,0.544,0.441,0.986,0.986,0.986c0.544,0,0.985-0.442,0.985-0.986v-2.105c0.004-1.996,1.618-3.611,3.614-3.614h4.836 c1.996,0.003,3.611,1.619,3.615,3.614v2.105c0,0.544,0.441,0.986,0.986,0.986S23.45,19.934,23.45,19.39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestLibraryIconPopular);
export default __webpack_public_path__ + "static/media/TEST_LIBRARY_ICON_POPULAR.ade45e51e9f5782606eb662f68d48b0e.svg";
export { ForwardRef as ReactComponent };